import merge from "./utils/merge"
import defaultOptions from './components/default_options'

export default (extendOptions = {}) => {
  return merge.clone(defaultOptions, extendOptions)
}
